<template>
    <div class="container-fluid px-0" id="wrapper-content-validador">
        <br>
        <transition name="fade">
        <div class="container-fluid">
           <!--  <div class="row d-flex px-lg-5">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <h5 class="text-center">VALIDACIÓN DE DOCUMENTOS CON FIRMA ELECTRÓNICA</h5>
              </div>
            </div> -->
            <div class="row d-flex px-lg-5">
              <div class="col-12 col-sm-12 col-md-12 col-lg-2 padding-div-low" style="margin-top:0px;margin-bottom:0px;"></div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-8 padding-div-low" style="margin-top:0px;margin-bottom:0px;">
                <form @submit.prevent="buscarDatos(paramTofind)">
                    <div class="row align-items-center">
                      <div class="form-group col-3">
                        <label>Código :</label>
                      </div>
                      <div class="form-group col-4">
                        <input type="text" class="form-control" v-model="paramTofind" />
                      </div>
                      <div class="form-group col-4">
                        <button type="submit" class="btn btn-sm btn-dark">Buscar</button>
                      </div>
                    </div>
                  </form>
                  <div class="row align-items-center" v-if="this.info.Fecha!=undefined && this.info.Fecha!=''">
                    <div class="form-group col-3" id="Area_div">
                      <label>Fecha de Firmado:</label>
                    </div>
                    <div class="form-group col-4" id="Area_div">
                      <input type="text" class="form-control" v-model="info.Fecha" readonly />
                    </div>
                  </div>
                  <div class="row align-items-center" v-if="this.info.firmantes.length>0">
                    <div class="form-group col-12 wrapper-container-info" id="Area_div">
                      <label>Firmantes:</label>
                      <ol v-for="item in info.firmantes" :key="item.id">
                        <template >
                          <li>{{item.signatoreName}}
                          </li>
                        </template>
                      </ol>
                    </div>
                  </div>
              </div>
              
            </div>
            <div class="row d-flex px-lg-5">
              
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low" style="margin-top:0px;margin-bottom:0px;" v-if="info.file!=null && info.file!=''" >
                <h3 class="text-center" >Vista previa del documento</h3>
                 
                  <object :data="info.file" type="application/pdf" width="100%" height="600px">
                      Tu navegador no soporta mostrar PDFs.
                    </object>
              </div>
             
            </div>
        </div>
        </transition>
    </div>
</template>

<script>

import axios from 'axios'
import comun from '@/../static/js/comun'
import PDFdocument from '@/components/Comunes/PDFDocument.vue';

export default {
    components: {
      PDFdocument
    }, 
    data() {
      return {
        paramTofind : '',
        qr: String,
        info: {
          Fecha: '',
          firmantes: [],
          file: '',
        },
        url: 'http://10.0.200.102:8085/microConsultaPublicaAcuse/api/signed-document/v1/validate/get-document-info?qrCode='
      }
    },
    created(){
        this.qr=this.$route.query.CodigoQR
    },
    mounted() {
      if(this.qr!='' && this.qr!=undefined)
      {
        this.buscarDatos(this.qr)
      }
      
    },
    watch: {
      paramTofind(valor) {
        if (valor !== this.$route.query.CodigoQR) {
          this.$router.replace({ 
            query: { ...this.$route.query, CodigoQR: valor } 
          });
        }
      },
      '$route.query.CodigoQR'(valor) {
        if (this.codigoQR !== valor) {
          this.codigoQR = valor || '';
        }
      }
    },
    methods: {
      buscarDatos: function(qr)
      {
        comun.SeEstaCargandoInformacion(true);

        axios.get(this.url + qr)
          .then( respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if(respuesta.data.headersResponse.statusCode==200)
            {
              this.paramTofind = respuesta.data.data.codeQR,
              this.info.Fecha = moment(respuesta.data.data.signedDate).locale('es').format("dddd D [de] MMMM [de] YYYY, h:mm a");
              this.info.firmantes = respuesta.data.data.signatoreList;
              this.info.file = ('data:application/pdf;base64,' + respuesta.data.data.fileContent);
            }

          })
          .catch(excepcion => {
            comun.SeEstaCargandoInformacion(false);
            this.info.Fecha = '';
            this.info.firmantes = [],
            this.info.rutaArchivo = null
            this.info.file = null;

            comun.mensajeDeAlerta("Error Interno del servidor o consulta no valida", null, null);
            
          })
      }
    }
}
</script>
<style scoped>

   label, li {
    color: black !important;
    font-size: 1.5em;
  }

  li {
    color: rgb(65, 65, 65) !important;
  }

  .wrapper-container-info {
    border: 1px solid #7a7a7a;
    padding: 1em 2em;
    border-radius: 4px;
    box-shadow: -8px 9px 4px -3px rgba(122,120,120,0.75);
    -webkit-box-shadow: -8px 9px 4px -3px rgba(122,120,120,0.75);
    -moz-box-shadow: -8px 9px 4px -3px rgba(122,120,120,0.75);
  }

  .page-title {
    background-color: rgb(33,33,33);
    color: black;
    padding: 2vh 20vw;
  }

  .div-principal-verificacionFirmas .alert-dark {
    color: black;
    background-color: #545757;
    border-color: #c6c8ca;
  }

  .alert-info-verificacionFirmas p > span {
    font-weight: 900;
    font-size: 1.3em;
  }
  input[type="text"]:read-only {
    background: #ffffff;
  }

  input[type="text"]:read-only:focus {
    border: 1px solid rgb(116, 116, 116);
    color: black;
    box-shadow: none;
  } 


</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Funciones/ValidaDocumentoFirmado/VistaValidaDocumentoFirmadoQR.vue